import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import SearchBar from "../../Snippets/TableCustomHooks/SearchBar";
import Loader from "../../Snippets/Loader";
import Table from "../../Snippets/TableCustomHooks/Table";
import Pagination from "../../Snippets/TableCustomHooks/Pagination";
import EmptyDataAlert from "../../Snippets/TableCustomHooks/EmptyDataAlert";

const OrdersTable = () => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  const [isLoading, setIsLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [userData, setUserData] = useState([]);
  const [allData, setAllData] = useState([]); // 🔥 full data for search
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");

  // ============================
  // FETCH ORDERS (API)
  // ============================
 const fetchOrders = async (pageNumber = 1, search = "") => {
  try {
    setIsLoading(true);
    setPage(pageNumber);

    const response = await axios.get(
      "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/cms_order/getAll_order",
      {
        params: {
          page: pageNumber,
          cd_Case_ID: search ? search : "", // ✅ IMPORTANT
          email: "",
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "module-id": "ORDER",
        },
      }
    );

    console.log("🔍 API Search Param:", search);
    // console.log("✅ API Response:", response.data);

    setUserData(response.data.data || []);
    setShowDetails(true);

  } catch (error) {
    console.error("❌ Error:", error.response?.data || error);
    setUserData([]);
    setShowDetails(false);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  const delay = setTimeout(() => {
    fetchOrders(1, searchValue);
  }, 500); // 🔥 debounce

  return () => clearTimeout(delay);
}, [searchValue]);

  // ============================
  // SEARCH (FRONTEND FILTER)
  // ============================
const handleSearch = (e) => {
  const value = e.target.value;
  setSearchValue(value);
};

  // ============================
  // INITIAL LOAD
  // ============================
 useEffect(() => {
  fetchOrders(1, "");
}, []);

  // ============================
  // TABLE COLUMNS
  // ============================
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Case No.",
        accessor: "cd_Case_ID",
      },
      {
        Header: "Title of the Matter",
        accessor: "subject",
      },
      {
        Header: "Date and Time",
        accessor: "date",
        Cell: ({ value }) =>
          value ? new Date(value).toLocaleString("en-IN") : "-",
      },
      {
        Header: "View Order",
        accessor: "order_Document",
        Cell: ({ row }) => {
          const docs = row.original.order_Document;

          return (
            <div className="my-2">
              {docs && docs.length > 0 ? (
                <a
                  href={docs[0]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
                >
                  View PDF
                </a>
              ) : (
                <span className="text-gray-400 text-sm">No File</span>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const data = React.useMemo(() => userData || [], [userData]);

  // ============================
  // UI
  // ============================
  return (
    <div className="flex mt-20 md:mt-20 bg-gray-200 min-h-screen p-3 sm:p-4 md:p-6 lg:ml-64">
      <div className="w-full max-w-[1200px] mx-auto">

        {/* HEADER */}
        <div className="py-5 sm:py-6 md:py-7">
          <h1 className="text-[18px] sm:text-[20px] md:text-[24px] font-semibold text-heading-clr">
            Orders
          </h1>
        </div>

        {/* SEARCH */}
        <div className="mb-4 sm:mb-5 md:mb-6">
          <SearchBar
            placeholder="Search Here"
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearch={handleSearch}
          />
        </div>

        {/* CONTENT */}
        {isLoading ? (
          <div className="flex justify-center items-center h-[200px]">
            <Loader />
          </div>
        ) : showDetails ? (
          <div className="mt-4 sm:mt-6 mb-10">

            {/* TABLE */}
            <div className="overflow-x-auto bg-white p-3 sm:p-4 rounded-lg shadow">
              <div className="min-w-[600px]">
                <Table columns={columns} data={data} />
              </div>
            </div>

            {/* PAGINATION */}
            <div className="flex justify-center mt-6">
              <Pagination
                goToNextPage={() => fetchOrders(page + 1)}
                goToPrevPage={() => fetchOrders(page - 1)}
              />
            </div>

          </div>
        ) : (
          <div className="mt-10 flex justify-center">
            <EmptyDataAlert title="No Data Found" />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersTable;